import { createRoot } from 'react-dom/client'
import './index.css'

const path = window.location.pathname;

if (path.startsWith('/lp/')) {
  // Marketing-studio landing pages are SSR'd by the server. The client only
  // hydrates the lead-form slot, leaving the rest of the SSR body intact.
  import('./landing/landingHydrator')
    .then(({ hydrateLandingPage }) => hydrateLandingPage())
    .catch((err) => console.error('[main] landing hydrator failed to load', err));
} else {
  // Standard SPA boot.
  Promise.all([import('./App')]).then(([{ default: App }]) => {
    createRoot(document.getElementById('root')!).render(<App />);
  });
}
